import React, {useMemo} from "react"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import {makeStyles} from "@material-ui/core/styles"
import {Dialog, Typography, Button, Divider} from "@material-ui/core"
import {useStore, useDispatch} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import {nl2br} from "../common"

const useStyles = makeStyles((theme) => ({
  root: {
    display: `flex`,
    flexDirection: `row`,
    flexWrap: `wrap`,
    justifyContent: `center`,
    width: `100%`,
  },
  title: {
    fontSize: `1.5rem`,
  },
  typo: {
    [theme.breakpoints.down(`sm`)]: {
      fontSize: `0.75rem`,
    },
  },
}))

export default function GuideDialog() {
  const {t} = useTranslation()
  const classes = useStyles()
  const {
    store: {locale, guideInfo},
  } = useStore()
  const {guideDialog} = guideInfo
  const {dispatch} = useDispatch()

  const handleClose = (value) => () => {
    const stepsEnabled = value === `on` ? true : false
    dispatch({
      type: `GUIDE_STEPS`,
      stepsEnabled,
    })
    dispatch({
      type: `GUIDE_DIALOG`,
      guideDialog: false,
    })
  }

  return useMemo(
    () => (
      <Dialog className={classes.root} open={guideDialog} onClose={handleClose(`off`)}>
        <DialogTitle className={classes.title}>{nl2br(t(`guideTitle`))}</DialogTitle>
        <Divider variant={`middle`} />
        <DialogContent>
          <Typography className={classes.typo}>{nl2br(t(`guideMessage`))}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose(`off`)}>{nl2br(t(`offButton`))}</Button>
          <Button onClick={handleClose(`on`)} autoFocus>
            {nl2br(t(`onButton`))}
          </Button>
        </DialogActions>
      </Dialog>
    ),
    [classes, guideDialog, locale],
  )
}
